import { Component, Input, ViewChild, ElementRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { HttpService } from '../../../../services/dataAccess.service';
import { CoreService } from '../../../../services/core.service';
import { PropertyData, ZoomModel, ZoomRecordingFile } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-video-zoom',
  templateUrl: './video-zoom.component.html',
  styleUrls: ['./video-zoom.component.css', '../../dynamictag.component.css']
})

export class VideoZoomComponent extends BaseAddOnComponent implements OnInit {

  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
  @Input('idEvent') idEvent: string;
  @Input('input') input: PropertyData;
  //@Output('inputChange') emitter: EventEmitter<PropertyData> = new EventEmitter<PropertyData>();

  @ViewChild('toggleModalInsee', { static: false }) toggleModalInsee: ElementRef;

  public listLinks: Array<string> = [];

  public dataList: Array<ZoomRecordingFile> = new Array();
  // #region CONSTRUCTEUR
  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private cd: ChangeDetectorRef,
  ) { super(); }
  // #endregion

  ngOnInit(): void {
    this.listLinks = this.input.MainElementList[0].Value.split('|');
    this.cd.detectChanges();
  }

  public RemoveFile(index: number): void {
    if (index < this.listLinks.length) {
      if (this.listLinks.length > 1) {
        this.listLinks.splice(index, 1);
      } else {
        this.listLinks[0] = '';
      }
    }
    //bind les liens avec l'input
    this.input.MainElementList[0].Value = '';
    let i: number = 1;
    this.listLinks.forEach((link: string) => {
      this.input.MainElementList[0].Value += link;
      if (i < this.listLinks.length) {
        this.input.MainElementList[0].Value += '|';
      }
      i++;
    });
    //this.emitter.emit(this.input);
  }
  public AddFile(): void {
    this.listLinks.push('');
  }

  public ChangeLinkValue(index: number, value: string): void {
    this.listLinks[index] = value;
    //bind les liens avec l'input
    this.input.MainElementList[0].Value = '';
    let i: number = 1;
    this.listLinks.forEach((link: string) => {
      this.input.MainElementList[0].Value += link;
      if (i < this.listLinks.length) {
        this.input.MainElementList[0].Value += '|';
      }
      i++;
    });
    //this.emitter.emit(this.input);
  }

  public GetRecordedFiles(): void {
    if (this.idEvent && this.idEvent !== '0') {
      this.indParam.showSplash(true);
      this.http.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/GET_RECORDING_FROM_BO/${this.idEvent}`).subscribe((result: ZoomModel) => {
        if (result && result.recording && result.recording.recording_files) {
          if (result.recording.recording_files.length === 1) {
            if (!this.input.MainElementList[0].Value) {
              this.input.MainElementList[0].Value = result.recording.recording_files[0].play_url;
            } else {
              const links: string[] = this.input.MainElementList[0].Value.split('|');
              let added: boolean = false;
              for (let i: number = 0; i < links.length; i++)
              {
                if (!links[i])
                {
                  links[i] = result.recording.recording_files[0].play_url;
                  added = true;
                  break;
                }
              }
              if (!added) {
                links.push(result.recording.recording_files[0].play_url);
              }
                this.input.MainElementList[0].Value = links.join('|');             
            }

            this.listLinks = this.input.MainElementList[0].Value.split('|');
          } else {
            this.dataList = new Array();
            result.recording.recording_files.forEach(
              (file: ZoomRecordingFile) => {
                this.dataList.push(file);
              });
          }
        }
        else {
          this.dataList = new Array();
        }
        this.indParam.showSplash(false);
      });
    }
  }

  // #endregion
  public navigToVideo(url: string): void {
    window.open(url, '_blank');
  }
}
